import { Box, Button, Divider } from "@mui/material";
import {
    StyledCard,
    StyledCardBody,
    StyledAppointmentInfo,
    StyledProfileImage,
    StyledStatus,
    StyledDoctorInfo,
    StyledDoctorFullname,
    StyledAppointmentDate,
    StyledDoctorBranch,
    StyledAppointmentDay,
    StyledAppointmentHour,
} from "./style";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import { useTranslation } from "react-i18next";
import { useDateFunc } from "../../hooks";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setSelectedBranchId } from "../../store/slices/categorySlice";
import { useConvertBackendDateOnly, useConvertBackendTimeOnly } from "../../utils/dateUtils";
import { formatBranchDisplay } from "../../utils/formatBranchDisplay";
import { getSpecialtyName } from "../../utils/taxonomyFields";
import { getPublicFileUrl } from "../../utils/storedFile";

const AppointmentCard = ({ id, doctor, status, bookedDate, children, branchId, isPassive = false }) => {
    const { profilePhotoName, firstName, lastName } = doctor || {};
    const specialtyDisplayName = getSpecialtyName(doctor) || (typeof doctor?.branch === "string" ? doctor.branch : "");
    const doctorProfileImage = getPublicFileUrl(profilePhotoName);
    const { t } = useTranslation();
    const { formatDate, getLocaleTime } = useDateFunc();
    const navigate = useNavigate();
    const dispatch = useDispatch();

    // Kullanıcının timezone'ında tarih ve saat
    const userDate = useConvertBackendDateOnly(bookedDate);
    const userTime = useConvertBackendTimeOnly(bookedDate);

    //---------------- RETURN ---------------------

    return (
        <>
            <StyledCard>
                <StyledCardBody>
                    <StyledProfileImage src={doctorProfileImage || ""} />
                    <StyledDoctorInfo>
                        <StyledDoctorFullname>{`${firstName} ${lastName}`}</StyledDoctorFullname>
                        <StyledDoctorBranch>{formatBranchDisplay(specialtyDisplayName)}</StyledDoctorBranch>
                    </StyledDoctorInfo>
                </StyledCardBody>
                <StyledAppointmentInfo>
                    <Box sx={{ flexDirection: "row", display: "flex", gap: "8px" }}>
                        <StyledStatus status={status.toLowerCase()}>
                            {t("status")}: <span>{t(status)}</span>
                        </StyledStatus>
                        <StyledAppointmentDay>
                            <CalendarMonthIcon />
                            <span>{userDate}</span>
                        </StyledAppointmentDay>
                        <StyledAppointmentHour>
                            <AccessTimeIcon />
                            <span>{userTime}</span>
                        </StyledAppointmentHour>
                    </Box>
                    <Button
                        onClick={() => {
                            navigate(`/appointments/${id}`);
                        }}
                    >
                        {t("detail")}
                    </Button>
                </StyledAppointmentInfo>
                {children}
                <Divider />
            </StyledCard>
        </>
    );
};

export default AppointmentCard;
